import { connect } from 'react-redux'
import Tax from '../../components/profile/tax.component'
import { closeTaxCardSnackbar, closeTaxCardErrorSnackbar } from '../../actions'

const mapStateToProps = (state) => {
  const { client, adminUser } = state
  const userType = client.user.data[5]

  return {
    showSpinner: state.tax.showTaxCardSpinner,
    showTaxCardSnackbar: state.tax.showTaxCardSnackbar,
    showTaxCardErrorSnackbar: state.tax.showTaxCardErrorSnackbar,
    userType,
    selectedUser: adminUser.selectedUser,
    noTaxCardFound: state.tax.noTaxCardFound
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    closeTaxCardSnackbar: () => dispatch(closeTaxCardSnackbar()),
    closeTaxCardErrorSnackbar: () => dispatch(closeTaxCardErrorSnackbar())
  }
}

// TODO: employ react-html-email to send a tax card to the administrator
// and save it to the backend
const TaxContainer = connect(mapStateToProps, mapDispatchToProps)(Tax)

export default TaxContainer
